export const retrievedGraphQLError = (error) => error?.message ?? null;

export const AUTH_ERROR_CODES = ['UNAUTHENTICATED', 'FORBIDDEN', 'AUTH_EXCEPTION'];

/**
 * Handle authentication errors and invalid business entity UUID errors
 * @param {object} options
 * @param {Array<object>} options.errors - array of ZBError objects
 * @returns {void}
 */
export const gqlErrorHandler = ({ errors = [] }) => {
  const authError = errors?.find(({ errorCode }) => AUTH_ERROR_CODES.includes(errorCode));

  // If someone provides a bad UUID, force re-login
  const invalidBusinessEntityUuidError = errors?.find(
    ({ errorCode, message }) =>
      (errorCode === 'FORBIDDEN' && message === 'Permission failure') ||
      (errorCode === 'BAD_USER_INPUT' && message.includes('UUID cannot represent non-UUID'))
  );
  /* if the user is trying to access a resource that returns 403 take them
        to the "home" page of the dashboard.
    */
  if (authError || invalidBusinessEntityUuidError) {
    const { pathname } = window.location;
    if (!pathname || !pathname.startsWith('/dashboard/logout')) {
      window.location.assign(`/dashboard/logout?redirectTo=${pathname}`);
    }
  }
};
